import { NgModule } from '@angular/core';
import { AMCMemberStoreService } from './amc-member-store.service';

@NgModule({
  providers: [AMCMemberStoreService],
})
export class AMCMemberStoreServiceModule {}
